var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconVolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/shopping"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-cricle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.1782 28.1173C33.8072 22.4883 33.8072 13.3753 28.1782 7.76074",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.82172 7.76074C2.19273 13.3897 2.19273 22.5027 7.82172 28.1173",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.249 31.4858C14.7894 32.0185 16.3874 32.2777 17.9998 32.2777C19.6122 32.2633 21.2102 32.0185 22.7506 31.4858",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.249 4.39197C14.7894 3.8593 16.3874 3.6001 17.9998 3.6001C19.6122 3.6001 21.2102 3.8593 22.7506 4.39197",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.2133 19.0366H15.716V24.8681C15.716 26.2288 16.453 26.5042 17.352 25.4836L23.4832 18.5183C24.2364 17.6678 23.9206 16.9632 22.7786 16.9632H20.2759V11.1317C20.2759 9.77102 19.5389 9.49565 18.6398 10.5162L12.5087 17.4815C11.7635 18.3401 12.0794 19.0366 13.2133 19.0366Z",
    fill: "#F7DE2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconVolt);
export default __webpack_public_path__ + "static/media/nav_icon_volt.25c365f766526e3cc8966f6f05cfce2c.svg";
export { ForwardRef as ReactComponent };